"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var layout_margin_reset_1 = __importDefault(require("../../_helpers/layout-margin-reset"));
var transform_layout_children_1 = __importDefault(require("../../_helpers/transform-layout-children"));
var styled_1 = __importDefault(require("../../styled"));
var tokens_1 = require("../../tokens");
var gutterOptions = {
    none: 0,
    xsmall: tokens_1.spacing.xsmall,
    small: tokens_1.spacing.small,
    medium: tokens_1.spacing.medium,
    large: tokens_1.spacing.xlarge
};
var RowLayout = function (props) { return (React.createElement(RowLayout.Element, __assign({}, automation_attribute_1.default('row-layout'), props), transform_layout_children_1.default(props, RowLayout.Item, 'row-layout.item'))); };
RowLayout.Element = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-gap: ", ";\n\n  & > *:empty {\n    display: none;\n  }\n\n  ", ";\n"], ["\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-gap: ", ";\n\n  & > *:empty {\n    display: none;\n  }\n\n  ", ";\n"])), function (props) { return gutterOptions[props.gutter]; }, layout_margin_reset_1.default());
RowLayout.Item = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
RowLayout.defaultProps = {
    gutter: 'medium'
};
exports.default = RowLayout;
var templateObject_1, templateObject_2;
//# sourceMappingURL=row-layout.js.map